import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class NotificationService{

        CALL_TYPE = {
            SIMPLE_PAGE_LOAD : 0,
            SIMPLE_PAGE_LOAD_GET_CONTENT : 1,
            POST_FORM_DATA : 2
        }

        notificationMessageBody:string;
        notificationMessageHeader:string;
        notificationTimeOut = 5000;
        //this will hold relative to the CALL_TYPE Enum styled object
        currentNotificationType:number;

        constructor(){

        }
}

